import React from "react";

import styles from "./CloneAssistantModal.module.css";

interface RadioOptionProps {
    name: string
    checked: boolean
    onSelect: () => void
    label: string
    description: string
}

/**
 * One choice in a small radio group. The admin UI has switches and selects but no radio group, and
 * these choices are mutually exclusive with an explanation attached to each.
 */
export const RadioOption: React.FC<RadioOptionProps> = ({name, checked, onSelect, label, description}) => (
    <label className={styles.option}>
        <input
            type="radio"
            name={name}
            checked={checked}
            onChange={onSelect}
            className={styles.radio}
        />
        <span className={styles.optionText}>
            <span className={styles.optionLabel}>{label}</span>
            <span className={styles.optionDescription}>{description}</span>
        </span>
    </label>
);
